var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0743 5.00192L9.99066 5.01801C9.94462 5.0269 9.70616 5.05284 9.4607 5.0757C7.1857 5.28752 4.8384 6.41639 3.12452 8.12293C1.48983 9.75066 0.461032 11.7957 0.101662 14.1317C0.0278769 14.6115 0.0207734 14.8295 0.00582291 17.0845C-0.00306556 18.4236 -0.00161493 19.5106 0.00905867 19.4999C0.0197323 19.4893 0.340126 18.7533 0.721066 17.8643C1.46442 16.1298 1.60329 15.847 2.03221 15.1941C3.35462 13.1809 5.3893 11.6778 7.70093 11.0063C8.42886 10.7949 9.09345 10.6763 9.95347 10.6043L10.0743 10.5942V12.8357C10.0743 14.0685 10.084 15.0772 10.0958 15.0772C10.1075 15.0772 11.4924 13.953 13.1733 12.5791C14.8541 11.2051 16.8527 9.57152 17.6147 8.94895C18.3766 8.32638 19 7.80525 19 7.79086C19 7.77231 11.0838 1.3045 10.1594 0.567729L10.0743 0.5V5.00192Z",
    fill: "#F3EC00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.272a7f877c65e36b23325280f17d5bb4.svg";
export { ForwardRef as ReactComponent };